import { useCallback, useEffect, useState } from 'react';
import type { HistoryEntry } from '@/utils/media';

const HISTORY_KEY = 'hn_history';
const MAX_HISTORY = 12;

function readHistory(): HistoryEntry[] {
  try {
    const raw = localStorage.getItem(HISTORY_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as HistoryEntry[]) : [];
  } catch {
    return [];
  }
}

export function useHistory() {
  const [history, setHistory] = useState<HistoryEntry[]>([]);

  useEffect(() => {
    setHistory(readHistory());
  }, []);

  const addHistory = useCallback((id: string) => {
    try {
      const current = readHistory().filter((item) => item.id !== id);
      const next = [{ id, at: Date.now() }, ...current].slice(0, MAX_HISTORY);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(next));
      setHistory(next);
    } catch {
      /* ignore */
    }
  }, []);

  const clearHistory = useCallback(() => {
    try {
      localStorage.removeItem(HISTORY_KEY);
    } catch {
      /* ignore */
    }
    setHistory([]);
  }, []);

  return { history, addHistory, clearHistory };
}